<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>Coffee Lab ანუ ყავა ხილია?</h1>
    <h6>დეკემბერი 2023</h6>
    <br />

    <img src="../../../../assets/blog/coffee-lab/img1.jpg" alt="" />

    <p>
      დილის პირველი ჭიქა გამოფხიზლებისთვის, მეორე ჭიქა - ენერგიისთვის, სამხარზე, ან სამხრის შემდეგ, ყავა როგორც
      მეგობართან გემრიელი საუბრის განუყოფელი ნაწილი, ან სასმელი, რომლის თანხლებითაც მნიშვნელოვანი გადაწყვეტილების
      მიღებისთვის ვხვდებით, ყავა, როგორც ურთიერთობის, დაკავშირების, ახალი ენერგიების ელექსირი. ამ მატონიზირებელ სასმელზე
      უსასრულოდ შემიძლია წერა, მაგრამ ჩემზე უფრო ფილოსოფიურად ამას Coffee Lab-ში აკეთებენ:
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ყავა ხილია, რომელიც იზრდება ხეზე და აქვს ტკბილი, წვნიანი, წითელი ნაყოფები, რომელთაც შეიძლება ჰქონდეს კენკრის,
        ატმის, ციტრუსის ან ნებისმიერი სხვა ხილის გამოკვეთილი საგემოვნო თვისებები.
      </b>
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/coffee-lab/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      როგორ შეიძლებოდა ხალხს, რომელსაც ასე სწამდა პროდუქტის, რაიმე ჩვეულებრივი, არაფრით გამორჩეული შეექმნა? სწორედ
      ამიტომ, თბილისში, უფრო სწორად, საქართველოში ერთ-ერთი პირველი Specialty ანუ “განსაკუთრებული“ ყავის სახელოსნო-კაფე
      დააარსეს. მათი ფილოსოფია მარტივია - უბრალოდ ყველასგან გამორჩეული გემო უნდა შესთავაზონ მომხმარებელს, რისთვისაც
      მსოფლიოს სხვადასხვა ქვეყნიდან ჩამოაქვთ განსაკუთრებული გემოვნური თვისებების მქონე მწვანე, მოუხალავი მარცვლები და
      თანამედროვე ტექნოლოგიების გამოყენებით ამუშავებენ. საბოლოო პროდუქტი მომჟავო-მოტკბო, ანუ ხილოვანი არომატისაა.
    </p>

    <p>
      ტრადიციული ყავისგან განსხვავებული, გამორჩეული გემოს მიღება, მომზადებისა და დაგემოვნების ალტერნატიული კულტურის
      დანერგვა – სწორედ ამ მიზნების მისაღწევად შემოიკრიბა 2016 წელს თანამოაზრეების გუნდი გიორგი აივაზიანმა და შექმნა
      „ყავის ლაბორატორია“ – პირველი განსაკუთრებული თვისებების მქონე ყავის კომპანია საქართველოში.
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ყავის მომზადება ჩვენთვის დიდი თავგადასავალია. „ყავის ლაბორატორიაში“ სპეციალური ტექნოლოგიის გამოყენებით იხალება
        იმპორტირებული მწვანე ყავის მარცვალი და მზადდება ინდივიდუალური გემოთი და არომატით გამორჩეული ყავა, რომელიც ჩვენ
        ასე ძალიან გვიყვარს.
      </b>
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/coffee-lab/img3.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      საქმიანობის განსავითარებლად, სარესტორნო ბიზნესში აპრობირებული მეთოდი, ლიზინგი გამოიყენეს. ტექნიკა-დანადგარების
      შესაძენად, ასევე გარკვეული ცვეთის შემდეგ ჩასანაცვლებლად მარტივი გზა, სწორედ ლიზინგია.
    </p>

    <p>
      დღეს Coffee Lab არა მხოლოდ რამდენიმე ფილიალს ფლობს თბილისში, არამედ საუკეთესო გემოვნური თვისებების ყავით ამარაგებს
      სხვა წამყვან კაფე-რესტორნებს.
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ჩვენი სურვილია, ყავის დაგემოვნება ვაქციოთ დაუვიწყარ გამოცდილებად ჩვენს ბარში, პარტნიორ რესტორნებში, კაფეებსა თუ
        თქვენს სახლშიც კი.
      </b>
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>Coffee Lab, is coffee a fruit?</h1>
    <h6>December 2023</h6>
    <br />

    <img src="../../../../assets/blog/coffee-lab/img1.jpg" alt="" />

    <p>
      The first cup of coffee in the morning for awakening, the second cup for energy, coffee as an inseparable part of
      a delicious conversation with a friend, or a drink that accompanies us when making important decisions, coffee as
      an elixir of relationships, connections, and new energies. I can write endlessly about this invigorating beverage,
      but more philosophically, Coffee Lab does this:
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        Coffee is a fruit that grows on a tree and has sweet, juicy, red fruits, which can have distinct taste
        characteristics of berries, peaches, citrus, or any other fruit.
      </b>
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/coffee-lab/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      How could people who believed so much in the product create anything ordinary, anything unremarkable? That is why,
      in Tbilisi, or rather, in Georgia, one of the first Specialty, or "special," coffee workshop-cafes was
      established. Their philosophy is simple – they just want to offer the customer a distinctive taste, for which they
      import green, unroasted beans with unique flavor characteristics from various countries around the world and
      process them using modern technologies. The final product has a tangy-sweet, fruity aroma.
    </p>

    <p>
      Unlike traditional coffee, achieving a distinctive taste, introducing an alternative culture of preparation and
      tasting – these are the goals that Giorgi Ayvazian gathered a team of like-minded people to achieve in 2016,
      creating "Coffee Lab" – the first specialty coffee company in Georgia.
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        Preparing coffee is a great adventure for us. At 'Coffee Lab,' the imported green coffee beans are roasted using
        special technology, and coffee with an individual taste and aroma is prepared, which we love so much.
      </b>
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/coffee-lab/img3.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      To develop the business, they used a method proven in the restaurant industry – leasing. Leasing is the simplest
      way to acquire equipment and machinery, as well as to replace them after some depreciation.
    </p>

    <p>
      Today, Coffee Lab not only owns several branches in Tbilisi but also supplies the best-tasting coffee to other
      leading cafes and restaurants.
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        Our desire is to turn coffee tasting into an unforgettable experience in our bar, partner restaurants, cafes, or
        even in your home.
      </b>
    </p>
  </div>
</ng-container>
